import { PropsWithChildren } from 'react';

import { ChakraVStack, Text } from '@equip.health/ui';

import { CLASS_MISSING_REQUIRED } from '~/components/common/inquiry/drawer/types';

interface InquiryDrawerLayoutProps extends PropsWithChildren {
  id: string;
  header: string;
  isMissingFields?: boolean;
}

const InquiryDrawerLayout = ({
  children,
  id,
  header,
  isMissingFields = false,
}: InquiryDrawerLayoutProps) => {
  return (
    <ChakraVStack
      align="flex-start"
      className={isMissingFields ? CLASS_MISSING_REQUIRED : undefined}
      gap="24px"
      width="100%"
    >
      <Text
        color="neutral.primary"
        id={`${id}__header`}
        marginBottom="-12px"
        variant="h5"
      >
        {header}
      </Text>
      {children}
    </ChakraVStack>
  );
};

export default InquiryDrawerLayout;
